export const howToRemoveData = [
	{
		icon: '🎇',
		title: 'howToRemoveData_title1',
		subtitle: 'howToRemoveData_subtitle1',
	},
	{
		icon: '✨',
		title: 'howToRemoveData_title2',
		subtitle: 'howToRemoveData_subtitle2',
	},
	{
		icon: '🖼',
		title: 'howToRemoveData_title3',
		subtitle: 'howToRemoveData_subtitle3',
	},
	{
		icon: '🤘',
		title: 'howToRemoveData_title4',
		subtitle: 'howToRemoveData_subtitle4',
	},
];
